module.exports = __webpack_public_path__ + "static/media/6H.7e76ae4c.svg";